import { Component } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  isLoading: Observable<boolean>;
  constructor(private spinnerService: SpinnerService) {
    this.isLoading = this.spinnerService.spinner$;
  }
}
